export const audenc = {
  audioEncoder: {
    'MPEG-2 AAC-LC ADTS': 'MPEG-2 AAC-LC ADTS',
    'MPEG-4 AAC-LC LOAS/LATM': 'MPEG-4 AAC-LC LOAS/LATM',
    '16-bit Pass-through': '16-bit Pass-through',
    'Opus': 'Opus',
   algorithm: { // Note only 1, 10, 21 and 50 are offered.
      1: '16-bit Pass-through', // PCM
      2: 'Pass-through', // AES3
      3: 'Pass-through', // AES3
      4: 'Pass-through', // AES3
      5: 'Pass-through', // AES3
      10: 'AAC-LC ADTS', // MPEG2
      11: 'Pass-through', // MPEG2
      12: 'Pass-through', // MPEG2
      13: 'Pass-through', // MPEG1
      14: 'Pass-through', // MPEG1
      20: 'AAC-LC ADTS', // MPEG4
      21: 'AAC-LC LAOS/LATM', // MPEG4 LAOS/LATM
      22: 'AAC-LC LATM', // MPEG4 LAOS/LATM
      23: 'AAC-LC LATM', // MPEG4 LAOS/LATM
      40: 'Pass-through', // DOLBY
      41: 'Pass-through', // DOLBY
      42: 'Pass-through', // DOLBY
      43: 'Pass-through', // DOLBY
      44: 'Pass-through', // DOLBY
      50: 'Opus',
      65536: 'Unknown'
    },
    states: {
      active: 'ENCODING',
      failed: 'FAILED',
      muted: 'MUTED',
      stopped: 'STOPPED',
    },
    mode: {
      monoLeft: 'Mono Left',
      monoRight: 'Mono Right',
      stereo: 'Stereo',
      surroundThree: '3.0 (3 ch)',
      surroundFour: '4.0 (4 ch)',
      surroundSix: '5.1 (6 ch)',
      surroundFive: '5.0 (5 ch)',
      surroundSeven: '7.0 (7 ch)',
      surroundEight: '7.1 (8 ch)',
    },
    notifications: {
      muteErrorMsg_plural: '{{count}} audio encoders could not be muted',
      muteErrorMsg: '{{count}} audio encoder could not be muted',
      settingsChangeErrorMsg: 'Audio encoder could not be updated',
      settingsChangeSuccessMsg: 'Audio encoder updated',
      startErrorMsg_plural: '{{count}} audio encoders could not be started',
      startErrorMsg: '{{count}} audio encoder could not be started',
      stopErrorMsg_plural: '{{count}} audio encoders could not be stopped',
      stopErrorMsg: '{{count}} audio encoder could not be stopped',
      unmuteErrorMsg_plural: '{{count}} audio encoders could not be unmuted',
      unmuteErrorMsg: '{{count}} audio encoder could not be unmuted',
    },
    settings: {
      algorithm: 'Codec',
      bitRate: 'Bitrate',
      bitRatePlaceholder: '{{min}} - {{max}} kbps',
      channelLayout: 'Input Channels',
      mode: 'Channel Mode',
      inputInterface: 'Input Interface',
      inputLevel: '0 dBFS Audio Level',
      lang: 'Language',
      sampleRate: 'Sample Rate',
      settings: 'Settings',
    },
    statistics: {
      encodedBitrate: 'Encoded Bitrate',
      encodedBytes: 'Encoded Bytes',
      encodedFrames: 'Encoded Frames',
      encoderErrors: 'Encoder Errors',
      encoderPTS: 'Encoder PTS',
      maxSampleValue: 'Maximum Sample Value',
      maximumVuLevel: 'Maximum VU Level',
      sampleRate: 'Sample Rate',

      encodedFramerate: 'Encoded Framerate',
      passthroughType: 'Pass-Through Type',
      passthroughDetectedAlgorithm: 'Detected Algorithm',
      passthroughDetectedSamplerate: 'Detected Samplerate',
      passthroughDetectedBitDepth: 'Detected Bit Depth',
      passthroughErrors: 'Pass-Through Errors',
    },
  },
};
